// extracted by mini-css-extract-plugin
module.exports = {"container":"IconNav_container__1H5B_"};